import { ActivityPreset } from "@/types/calculator";

export const ACTIVITY_PRESETS: ActivityPreset[] = [
  {
    id: "beginner",
    name: "Beginner Walk",
    description: "Gentle pace for newcomers",
    speed: { metric: 3.5, imperial: 2.2 },
    intensity: "easy",
    terrain: "flat",
    met: 2.8,
  },
  {
    id: "brisk",
    name: "Brisk Walk",
    description: "Standard fitness walking",
    speed: { metric: 5.5, imperial: 3.4 },
    intensity: "brisk",
    terrain: "flat",
    met: 4.3,
  },
  {
    id: "power",
    name: "Power Walk",
    description: "Fast-paced walking workout",
    speed: { metric: 6.5, imperial: 4.0 },
    intensity: "brisk",
    terrain: "flat",
    met: 5.0,
  },
  {
    id: "nordic",
    name: "Nordic Walking",
    description: "Walking with poles, upper body engaged",
    speed: { metric: 5.0, imperial: 3.1 },
    intensity: "moderate",
    terrain: "flat",
    met: 5.2,
  },
  {
    id: "rucking",
    name: "Rucking",
    description: "Walking with weighted backpack",
    speed: { metric: 4.8, imperial: 3.0 },
    intensity: "moderate",
    terrain: "flat",
    met: 6.5,
  },
  {
    id: "hills",
    name: "Hill Walking",
    description: "Moderate to steep incline",
    speed: { metric: 4.0, imperial: 2.5 },
    intensity: "moderate",
    terrain: "hilly",
    met: 6.3,
  },
];
